<button
    mat-button
    (click)="toggleClicked()"
>
    <ng-content></ng-content>
    <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        [class]="clicked ? 'rotated' : ''"
    >
        arrow_drop_down
    </mat-icon>
</button>
